import { useIntl } from 'react-intl';

import { Mail } from '@calm-web/icons';

import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAuth } from '@/context/auth/AuthProvider';
import { CalmAuthMethods } from '@/utils/privacyCookies';

import messages from './messages';
import { Wrapper } from './styles';
import { EmailAuthButtonProps } from './types';

const EmailAuthButton = ({
	marketingOptIn,
	onAuthSuccess,
	buttonCTA,
	loginHint,
	isDarkBackground,
}: EmailAuthButtonProps) => {
	const { authenticate } = useAuth();
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();

	const getButtonCta = () => {
		if (buttonCTA) {
			return typeof buttonCTA === 'string' ? buttonCTA : formatMessage(buttonCTA);
		}
		return authPrompt === 'login'
			? formatMessage(messages.emailSignInCta)
			: formatMessage(messages.emailContinueCta);
	};

	const handleClick = () => {
		authenticate({ authMethod: CalmAuthMethods.Email, marketingOptIn, onAuthSuccess, loginHint });
	};

	const buttonCta = getButtonCta();

	return (
		<Wrapper
			$noPadding={false}
			backgroundColor={isDarkBackground ? 'white' : 'blue7'}
			borderColor={isDarkBackground ? 'white' : 'blue7'}
			textColor={isDarkBackground ? 'black' : 'white'}
			iconColor={isDarkBackground ? 'black' : undefined}
			contentAlignment="center"
			data-testid="email-button"
			Icon={Mail}
			onPress={handleClick}
			role="link"
		>
			{buttonCta}
		</Wrapper>
	);
};

export default EmailAuthButton;
